// Name-based row mapping. Server responses carry `columns` plus `rows` whose
// cells are positionally aligned to THAT SAME `columns` list. Never index a row
// with positions taken from a different list (the initial widget payload, a
// "preferred order", a hardcoded column set) — that is how values end up under
// the wrong heading when the active database or the selection changes.

export const FIELD_NOT_AVAILABLE = "Field not available";

const lower = (s) => String(s ?? "").toLowerCase();

/** Convert positional rows into objects keyed by their own column names. */
export function rowsToObjects(columns, rows) {
  const cols = (columns || []).map(String);
  return (rows || []).map((row) => {
    if (!Array.isArray(row)) return row || {};
    const obj = {};
    cols.forEach((c, i) => { obj[c] = row[i]; });
    return obj;
  });
}

/** Case-insensitive lookup of a column's value in a row object. */
export function cellByName(rowObj, column) {
  if (!rowObj) return FIELD_NOT_AVAILABLE;
  if (column in rowObj) return rowObj[column];
  const key = Object.keys(rowObj).find((k) => lower(k) === lower(column));
  return key === undefined ? FIELD_NOT_AVAILABLE : rowObj[key];
}

/**
 * Re-project rows (aligned to `sourceColumns`) onto `wantedColumns` by name.
 * A wanted column the source cannot supply renders as FIELD_NOT_AVAILABLE.
 */
export function projectRows(sourceColumns, rows, wantedColumns) {
  const objects = rowsToObjects(sourceColumns, rows);
  return objects.map((obj) => (wantedColumns || []).map((c) => cellByName(obj, c)));
}

export function isFieldNotAvailable(value) {
  return value === FIELD_NOT_AVAILABLE;
}
